import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from 'src/app/interfaces';
import { IRelatorioTaxaFixaEProducaoBody } from 'src/app/interfaces/relatorio/TaxaFixaEProducao/IRelatorioTaxaFixaEProducaoBody';
import { IRelatorioTaxaFixaEProducaoResponseData } from 'src/app/interfaces/relatorio/TaxaFixaEProducao/IRelatorioTaxaFixaEProducaoResponseData';

@Injectable({
  providedIn: 'root'
})
export class RelatorioTaxaFixaEProducaoService {
  private readonly baseURL = '/RelatorioTaxaFixaEProducao';

  constructor(private httpClient: HttpClient) {}

  postRelatorioTaxaFixaEProducao(body: IRelatorioTaxaFixaEProducaoBody) {
    return this.httpClient.post<
      IApiResponse<IRelatorioTaxaFixaEProducaoResponseData>
    >(this.baseURL, body);
  }
}
